query MobileSdkUsageData(
	$daysAmountFilter: ConditionInt
	$daysAmountx2Filter: ConditionInt
	$textSearch: msdk_report_runsSearchInsensitive
	$customFieldsFilter: ConditionStringArray
	$osFilter: ConditionString
	$appFilter: ConditionString
	$appVersionFilter: ConditionString
	$sdkTypeFilter: ConditionString
	$sdkVersionFilter: ConditionString
	$severityOrFilter: [msdk_report_runsOrFilter!]
) {
	last_n_days: msdk_report_runs(
		run_time_last_n_days: $daysAmountFilter
		text_contains: $textSearch
		custom_fields_eq_any_item_for_any_value: $customFieldsFilter
		os_eq_any_item: $osFilter
		app_eq_any_item: $appFilter
		app_version_eq_any_item: $appVersionFilter
		sdk_type_eq: $sdkTypeFilter
		product_version_eq_any_item: $sdkVersionFilter
		or: $severityOrFilter
	) {
		run_id_count
		total_issues_sum
		critical_issues_sum
	}
	last_2n_days: msdk_report_runs(
		run_time_last_n_days: $daysAmountx2Filter
		text_contains: $textSearch
		custom_fields_eq_any_item_for_any_value: $customFieldsFilter
		os_eq_any_item: $osFilter
		app_eq_any_item: $appFilter
		app_version_eq_any_item: $appVersionFilter
		sdk_type_eq: $sdkTypeFilter
		product_version_eq_any_item: $sdkVersionFilter
		or: $severityOrFilter
	) {
		run_id_count
		total_issues_sum
		critical_issues_sum
	}
}

query RecentMobileSdkUsageData(
	$daysAmountFilter: ConditionInt
	$daysAmountx2Filter: ConditionInt
	$textSearch: msdk_report_runs_latestSearchInsensitive
	$customFieldsFilter: ConditionStringArray
	$osFilter: ConditionString
	$appFilter: ConditionString
	$appVersionFilter: ConditionString
	$sdkTypeFilter: ConditionString
	$sdkVersionFilter: ConditionString
	$severityOrFilter: [msdk_report_runs_latestOrFilter!]
) {
	last_n_days: msdk_report_runs_latest(
		run_time_last_n_days: $daysAmountFilter
		text_contains: $textSearch
		custom_fields_eq_any_item_for_any_value: $customFieldsFilter
		os_eq_any_item: $osFilter
		app_eq_any_item: $appFilter
		app_version_eq_any_item: $appVersionFilter
		sdk_type_eq: $sdkTypeFilter
		product_version_eq_any_item: $sdkVersionFilter
		or: $severityOrFilter
	) {
		run_id_count
		total_issues_sum
		critical_issues_sum
	}
	last_2n_days: msdk_report_runs_latest(
		run_time_last_n_days: $daysAmountx2Filter
		text_contains: $textSearch
		custom_fields_eq_any_item_for_any_value: $customFieldsFilter
		os_eq_any_item: $osFilter
		app_eq_any_item: $appFilter
		app_version_eq_any_item: $appVersionFilter
		sdk_type_eq: $sdkTypeFilter
		product_version_eq_any_item: $sdkVersionFilter
		or: $severityOrFilter
	) {
		run_id_count
		total_issues_sum
		critical_issues_sum
	}
}
